import {
  DataSource,
  GraphQLConnector as Connector,
  ResponseDataTransformer
} from 'webpanel-data';
import { ENV } from '../env';

const connector = new Connector({
  responseDataTransformer: new ResponseDataTransformer()
});

export const api = new DataSource('api', connector, ENV.REACT_APP_API_URL);



// WEBPACK FOOTER //
// ./src/model/api.tsx